<!--
  Vue wrapper for Bryntum DateTimeField
-->

<template>

</template>

<script>

import { Base, DateTimeField, Mask, Rectangle, Scroller, Widget } from '@bryntum/scheduler';

import WrapperHelper from './WrapperHelper.js';
import WrapperHelperVue2 from './WrapperHelperVue2.js';

export default {

    name : 'BryntumDateTimeField',

    props : {

         // Configs only
        adopt                   : { type : [HTMLElement, String], default : undefined },
        align                   : { type : [Object, String], default : undefined },
        anchor                  : { type : Boolean, default : undefined },
        appendTo                : { type : [HTMLElement, String], default : undefined },
        autoComplete            : { type : String, default : undefined },
        centered                : { type : Boolean, default : undefined },
        clearable               : { type : [Boolean, Object], default : undefined },
        cls                     : { type : [String, Object], default : undefined },
        config                  : { type : Object, default : undefined },
        constrainTo             : { type : [HTMLElement, Widget, Rectangle], default : undefined },
        contentElementCls       : { type : [String, Object], default : undefined },
        dateField               : { type : Object, default : undefined },
        defaultBindProperty     : { type : String, default : undefined },
        dock                    : { type : String, default : undefined },
        draggable               : { type : [Boolean, Object], default : undefined },
        editable                : { type : Boolean, default : undefined },
        floating                : { type : Boolean, default : undefined },
        hideAnimation           : { type : [Boolean, Object], default : undefined },
        highlightExternalChange : { type : Boolean, default : undefined },
        hint                    : { type : [String, Function], default : undefined },
        hintHtml                : { type : [String, Function], default : undefined },
        htmlCls                 : { type : [String, Object], default : undefined },
        inputAlign              : { type : String, default : undefined },
        inputAttributes         : { type : Object, default : undefined },
        inputWidth              : { type : [String, Number], default : undefined },
        insertBefore            : { type : [HTMLElement, String], default : undefined },
        insertFirst             : { type : [HTMLElement, String], default : undefined },
        keyStrokeChangeDelay    : { type : Number, default : undefined },
        labelCls                : { type : [String, Object], default : undefined },
        labelPosition           : { type : String, default : undefined },
        labels                  : { type : Object, default : undefined },
        labelWidth              : { type : [String, Number], default : undefined },
        listeners               : { type : Object, default : undefined },
        localeClass             : { type : Base, default : undefined },
        localizableProperties   : { type : Array, default : undefined },
        maskDefaults            : { type : [Object, Mask], default : undefined },
        masked                  : { type : [Boolean, String, Object, Mask], default : undefined },
        monitorResize           : { type : Boolean, default : undefined },
        name                    : { type : String, default : undefined },
        owner                   : { type : Widget, default : undefined },
        placeholder             : { type : String, default : undefined },
        positioned              : { type : Boolean, default : undefined },
        preventTooltipOnTouch   : { type : Boolean, default : undefined },
        required                : { type : Boolean, default : undefined },
        revertOnEscape          : { type : Boolean, default : undefined },
        ripple                  : { type : [Boolean, Object], default : undefined },
        rootElement             : { type : ShadowRoot, default : undefined },
        scrollAction            : { type : String, default : undefined },
        showAnimation           : { type : [Boolean, Object], default : undefined },
        tab                     : { type : [Boolean, Object], default : undefined },
        tag                     : { type : String, default : undefined },
        textAlign               : { type : String, default : undefined },
        timeField               : { type : Object, default : undefined },
        title                   : { type : String, default : undefined },
        weekStartDay            : { type : Number, default : undefined },
        weight                  : { type : Number, default : undefined },

         // Configs and properties
        alignSelf  : { type : [String], default : undefined },
        badge      : { type : [String], default : undefined },
        content    : { type : [String], default : undefined },
        dataset    : { type : [Object], default : undefined },
        disabled   : { type : [Boolean], default : undefined },
        extraData  : { type : [Boolean, Number, Object, String], default : undefined },
        flex       : { type : [Number, String], default : undefined },
        height     : { type : [Number, String], default : undefined },
        hidden     : { type : [Boolean], default : undefined },
        html       : { type : [String], default : undefined },
        id         : { type : [String], default : undefined },
        label      : { type : [String], default : undefined },
        margin     : { type : [Number, String], default : undefined },
        maxHeight  : { type : [Number, String], default : undefined },
        maxWidth   : { type : [Number, String], default : undefined },
        minHeight  : { type : [Number, String], default : undefined },
        minWidth   : { type : [Number, String], default : undefined },
        readOnly   : { type : [Boolean], default : undefined },
        scrollable : { type : [Boolean, Scroller, Object], default : undefined },
        tooltip    : { type : [Object, String], default : undefined },
        triggers   : { type : [Object], default : undefined },
        value      : { type : [String, Object], default : undefined },
        width      : { type : [Number, String], default : undefined },
        x          : { type : [Number], default : undefined },
        y          : { type : [Number], default : undefined },

         // Properties only
        anchorSize : { type : Array, default : undefined },

         // Events
        onAction        : { type : Function, default : undefined },
        onBeforeDestroy : { type : Function, default : undefined },
        onBeforeHide    : { type : Function, default : undefined },
        onBeforeShow    : { type : Function, default : undefined },
        onCatchAll      : { type : Function, default : undefined },
        onChange        : { type : Function, default : undefined },
        onClear         : { type : Function, default : undefined },
        onDestroy       : { type : Function, default : undefined },
        onFocusIn       : { type : Function, default : undefined },
        onFocusOut      : { type : Function, default : undefined },
        onHide          : { type : Function, default : undefined },
        onInput         : { type : Function, default : undefined },
        onPaint         : { type : Function, default : undefined },
        onReadOnly      : { type : Function, default : undefined },
        onResize        : { type : Function, default : undefined },
        onShow          : { type : Function, default : undefined },
        onTrigger       : { type : Function, default : undefined },

    },

    data : () => {
        return {
            instanceClass : DateTimeField,

            configNames : [
                'adopt',
                'align',
                'anchor',
                'appendTo',
                'autoComplete',
                'centered',
                'clearable',
                'cls',
                'config',
                'constrainTo',
                'contentElementCls',
                'dateField',
                'defaultBindProperty',
                'dock',
                'draggable',
                'editable',
                'floating',
                'hideAnimation',
                'highlightExternalChange',
                'hint',
                'hintHtml',
                'htmlCls',
                'inputAlign',
                'inputAttributes',
                'inputWidth',
                'insertBefore',
                'insertFirst',
                'keyStrokeChangeDelay',
                'labelCls',
                'labelPosition',
                'labels',
                'labelWidth',
                'listeners',
                'localeClass',
                'localizableProperties',
                'maskDefaults',
                'masked',
                'monitorResize',
                'name',
                'owner',
                'placeholder',
                'positioned',
                'preventTooltipOnTouch',
                'required',
                'revertOnEscape',
                'ripple',
                'rootElement',
                'scrollAction',
                'showAnimation',
                'tab',
                'tag',
                'textAlign',
                'timeField',
                'title',
                'weekStartDay',
                'weight'
            ],

            propertyConfigNames : [
                'alignSelf',
                'badge',
                'content',
                'dataset',
                'disabled',
                'extraData',
                'flex',
                'height',
                'hidden',
                'html',
                'id',
                'label',
                'margin',
                'maxHeight',
                'maxWidth',
                'minHeight',
                'minWidth',
                'onAction',
                'onBeforeDestroy',
                'onBeforeHide',
                'onBeforeShow',
                'onCatchAll',
                'onChange',
                'onClear',
                'onDestroy',
                'onFocusIn',
                'onFocusOut',
                'onHide',
                'onInput',
                'onPaint',
                'onReadOnly',
                'onResize',
                'onShow',
                'onTrigger',
                'readOnly',
                'scrollable',
                'tooltip',
                'triggers',
                'value',
                'width',
                'x',
                'y'
            ],

            propertyNames : [
                'anchorSize'
            ],

            eventNames : [
                'action',
                'beforeDestroy',
                'beforeHide',
                'beforeShow',
                'catchAll',
                'change',
                'clear',
                'destroy',
                'focusIn',
                'focusOut',
                'hide',
                'input',
                'paint',
                'resize',
                'show',
                'trigger'
            ]
        };
    },

    /**
     * Called after the instance has been mounted
     */
    mounted() {
        const
            me = this,
            {
                createWidget,
                relayStores,
                watchProps
            }  = WrapperHelper(),
            {
                processCellContent,
                hasFrameworkRenderer
            }  = WrapperHelperVue2();

        me.instance = createWidget({
            me,
            props   : me.$props,
            data    : me.$data,
            emit    : me.$emit.bind(me),
            element : me.$el
        });

        const watcher = me.$watch.bind(me);
        watchProps(me, me.instance, me.$props, me.$data, watcher);
    },

    /**
     * Called right before a Vue instance is destroyed. At this stage the instance is still fully functional.
     */
    beforeDestroy() {
        if (this.instance) {
            this.instance.destroy();
        }
    }

};

</script>
